import { render, staticRenderFns } from "./repost-ui.vue?vue&type=template&id=23ae99b0"
import script from "./repost-ui.vue?vue&type=script&lang=js"
export * from "./repost-ui.vue?vue&type=script&lang=js"
import style0 from "./repost-ui.vue?vue&type=style&index=0&id=23ae99b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports